import React, { Fragment, useState } from 'react';
import DocAdminListView from "./DocAdminListView";
import DocAdminDetailsView from "./DocAdminDetailsView";
import DocAdminNewView from "./DocAdminNewView";


const DocAdmin = () => {

  const [uiMode,     setUIMode]     = useState('LIST');
  const [objDetails, setObjDetails] = useState({});
  const [pageState,  setPageState]  = useState({
                                        searchTerms: null,
                                        sortCol:     null,
                                        sortDir:     null,
                                        perPage:     25,
                                        currPage:    1});

  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <DocAdminListView    pageState={pageState} onUIMode={setUIMode}
                                                     onSetPageState={setPageState} onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <DocAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <DocAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default DocAdmin;
